import { Assets, Graphics, Text, Application, Container, Texture, Sprite, TextStyle } from 'pixi.js';
import { Point } from '../models/point';
import { CardData } from '../models/card-data';
import { Card } from './card';
import { Observable, Subject, combineLatest, map, merge, of, switchMap, tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GameCardSorting } from '@app/store/features/games/games.reducer';
import { CardSuits } from '../helpers/card-decoder';
import { sortCards } from '../helpers/sort-card';
import { CardSize } from '@app/store/features/config/config.reducer';
import { th } from 'date-fns/locale';




export class PlayerCardsController {
    private _isDestroyed = false;

    readonly playerZoneWidth = 355
    readonly playerZoneHeight = 295
    readonly playerAvatarCircleSize = 150
    readonly infoBoxWidth = 260
    inRowVisibleCardWidth = 86
    cardSize: CardSize;
    container = new Container();


    cards: Card[] = [];
    r2tCards: Card[] = [];
    expandedCardsBackground: Graphics = new Graphics();

    cards$ = new Subject<Card[]>();
    cardsSelected$: Observable<{ cards: CardData[], indexes: number[] }>;

    isSelectable: boolean = false;
    isExpanded: boolean = false;

    constructor(cardSize: CardSize) {
        this.cardSize = cardSize;
        switch (cardSize) {
            case CardSize.normal:
                this.inRowVisibleCardWidth = 86 * 1;
                break;
            case CardSize.large:
                this.inRowVisibleCardWidth = 86 * 1.2
                break;
            case CardSize.extraLarge:
                this.inRowVisibleCardWidth = 86 * 1.4
                break;
            default:
                this.inRowVisibleCardWidth = 86 * 1
                break;
        }

        this.expandedCardsBackground = new Graphics();
        this.expandedCardsBackground.rect(0, 0, 0, 0).fill({ color: 0x000000, alpha: 0.9 });
        this.container.addChild(this.expandedCardsBackground);

        this.cardsSelected$ = this.cards$.pipe(
            switchMap(cards =>
                combineLatest([
                    of(cards),
                    merge(...cards.map(card => card.cardSelected$))
                ])
            ),
            map(([cards, data]) => {
                const selectedCards = cards.filter(card => card.selected).map(card => card.info!).map(card => {
                    delete card.textures; // remove textures from card info because of RxJS circular structure error
                    return card;
                });
                const indexesOld = selectedCards.map(card => cards.findIndex(c => c.info.name === card.name));
                const indexes = cards.filter(card => card.selected).map(card => card.apiCardIndex);


                console.log('Indexes:', indexes, 'index old', indexesOld)
                return { cards: selectedCards, indexes }
            })
        )
        if (false) {
            setTimeout(() => {
                this.addCards([
                    // #1
                    { suit: 0, number: 9, name: 'c2', isHidden: false, isRabbitHunting: undefined, textures: { cardTexture: Assets.get(`playerCardAtlas-0`).textures[`style_id_0_c2.png`], rabbitHuntingCardCover: {} as any } },
                    { suit: 0, number: 9, name: 'c3', isHidden: false, isRabbitHunting: undefined, textures: { cardTexture: Assets.get(`playerCardAtlas-0`).textures[`style_id_0_c3.png`], rabbitHuntingCardCover: {} as any } },
                    { suit: 0, number: 9, name: 'c4', isHidden: false, isRabbitHunting: undefined, textures: { cardTexture: Assets.get(`playerCardAtlas-0`).textures[`style_id_0_c4.png`], rabbitHuntingCardCover: {} as any } },
                    { suit: 0, number: 9, name: 'c5', isHidden: false, isRabbitHunting: undefined, textures: { cardTexture: Assets.get(`playerCardAtlas-0`).textures[`style_id_0_c5.png`], rabbitHuntingCardCover: {} as any } },
                    { suit: 0, number: 9, name: 'c6', isHidden: false, isRabbitHunting: undefined, textures: { cardTexture: Assets.get(`playerCardAtlas-0`).textures[`style_id_0_c6.png`], rabbitHuntingCardCover: {} as any } },

                    //  { suit: 0, number: 9, name: 'h9', isHidden: false, isPublic:true, isRabbitHunting: undefined, textures: { cardTexture: Assets.get(`playerCardAtlas-0`).textures[`style_id_0_c2.png`], rabbitHuntingCardCover: {} as any } },

                    // #2
                    // { suit: 0, number: 9, name: 'h9', isHidden: true, isRabbitHunting: undefined, texture: Assets.get('game-playerCardAtlas').textures['h9.png'] },
                    // { suit: 0, number: 9, name: 'h9', isHidden: true, isRabbitHunting: undefined, texture: Assets.get('game-playerCardAtlas').textures['h8.png'] },
                    // { suit: 0, number: 9, name: 'h9', isHidden: true, isRabbitHunting: undefined, texture: Assets.get('game-playerCardAtlas').textures['h7.png'] },
                    // { suit: 0, number: 9, name: 'h9', isHidden: true, isRabbitHunting: undefined, texture: Assets.get('game-playerCardAtlas').textures['h6.png'] },
                    // { suit: 0, number: 9, name: 'h9', isHidden: true, isRabbitHunting: undefined, texture: Assets.get('game-playerCardAtlas').textures['h5.png'] },
                    // { suit: 0, number: 9, name: 'h9', isHidden: true, isRabbitHunting: undefined, texture: Assets.get('game-playerCardAtlas').textures['h4.png'] },
                    // // { suit: 0, number: 9, name: 'h9', isHidden: false, isRabbitHunting: undefined, texture: Assets.get('game-backCard') },
                    // { suit: 0, number: 9, name: 'h9', isHidden: false, isRabbitHunting: undefined, texture: Assets.get('game-backCard') },

                    // #3
                    // { suit: 0, number: 9, name: 'h9', isHidden: true, isRabbitHunting: undefined, texture: Assets.get('game-backCard') },
                    // { suit: 0, number: 9, name: 'h9', isHidden: true, isRabbitHunting: undefined, texture: Assets.get('game-backCard') },
                    // { suit: 0, number: 9, name: 'h9', isHidden: true, isRabbitHunting: undefined, texture: Assets.get('game-backCard') },
                    // { suit: 0, number: 9, name: 'h9', isHidden: true, isRabbitHunting: undefined, texture: Assets.get('game-backCard') },
                    // { suit: 0, number: 9, name: 'h9', isHidden: true, isRabbitHunting: undefined, texture: Assets.get('game-backCard') },
                    // { suit: 0, number: 9, name: 'h9', isHidden: true, isRabbitHunting: undefined, texture: Assets.get('game-backCard') },
                    // { suit: 0, number: 9, name: 'h9', isHidden: true, isRabbitHunting: undefined, texture: Assets.get('game-backCard') },

                ], GameCardSorting.Default, false)

                this.addR2TCards([
                    // #1
                    { suit: 0, number: 9, name: 'd2', isHidden: false, isRabbitHunting: undefined, textures: { cardTexture: Assets.get(`playerCardAtlas-0`).textures[`style_id_0_d2.png`], rabbitHuntingCardCover: {} as any } },
                    { suit: 0, number: 9, name: 'd3', isHidden: false, isRabbitHunting: undefined, textures: { cardTexture: Assets.get(`playerCardAtlas-0`).textures[`style_id_0_d3.png`], rabbitHuntingCardCover: {} as any } },
                    { suit: 0, number: 9, name: 'd4', isHidden: false, isRabbitHunting: undefined, textures: { cardTexture: Assets.get(`playerCardAtlas-0`).textures[`style_id_0_d4.png`], rabbitHuntingCardCover: {} as any } },
                    { suit: 0, number: 9, name: 'd5', isHidden: false, isRabbitHunting: undefined, textures: { cardTexture: Assets.get(`playerCardAtlas-0`).textures[`style_id_0_d5.png`], rabbitHuntingCardCover: {} as any } },
                    { suit: 0, number: 9, name: 'd6', isHidden: false, isRabbitHunting: undefined, textures: { cardTexture: Assets.get(`playerCardAtlas-0`).textures[`style_id_0_d6.png`], rabbitHuntingCardCover: {} as any } },
                ])

                setTimeout(() => {
                    //     this.expandCards()

                    setTimeout(() => {
                        //   this.collapseCards()
                    }, 5000);
                }, 3000);
            }, 1000);


        }
    }



    update(dt: number) {
        this.cards.forEach(card => {
            card.update(dt);
        });
    }

    addCards(cards: CardData[], cardSorting: GameCardSorting, isRotated: boolean = false) {
        console.log('Adding cards:', ...cards, 'sorting', cardSorting, 'isRotated', isRotated)
        sortCards(cards, cardSorting)
            .forEach((cardData, index) => {
                const cardIndex = isRotated && cardData.isHidden ? 0 : this.container.children.length;
                let card = new Card(cardData.textures!, { info: cardData, isRotated, apiCardIndex: cardData.apiCardIndex ?? -1 });
                card = this.setCard(card, index, isRotated, !!cardData.isPublic, cards)

                card.setCardSelectionStatus(this.isSelectable)
                this.cards.push(card);
                this.container.addChildAt(card.container, cardIndex);
            });


        this.cards$.next(this.cards)
    }

    addR2TCards(cards: CardData[]) {
        cards.forEach((cardData, index) => {
            let card = new Card(cardData.textures!, { info: cardData, isRotated: false, apiCardIndex: index });
            card.container.scale.set(this.inRowVisibleCardWidth / card.cardSprite.texture.width)


            card.setAnchor(1, 0);

            const x = this.cards[this.cards.length - 1 - index].container.x + this.cards[this.cards.length - 1 - index].container.width

            let cardSizeYOffset = 10;
            if (this.cardSize === CardSize.large) {
                cardSizeYOffset -= 24;
            } else if (this.cardSize === CardSize.extraLarge) {
                cardSizeYOffset -= 50;
            }

            card.setPosition(x, cardSizeYOffset);


            card.setCardSelectionStatus(false)
            this.r2tCards.push(card);
            this.container.addChildAt(card.container, 0);
        });
    }



    updateCardSorting(cardSorting: GameCardSorting) {

        this.container.removeChildren();
        this.expandedCardsBackground.clear();
        this.container.addChild(this.expandedCardsBackground);

        const cards = this.cards.map(card => card.info!);
        sortCards(cards, cardSorting)
            .forEach((cardData, index) => {
                let card = this.cards.find(c => c.info.name === cardData.name);
                const cardIndex = card!.isRotated && cardData.isHidden ? 0 : this.container.children.length;

                card = this.setCard(card!, index, card!.isRotated, !!card?.info.isPublic, cards)
                this.container.addChildAt(card.container, cardIndex);

            })
    }



    /**
     * @description
     * Expand and collapse cards used for Draw games on mobile devices and vertical table rotation
     */

    expandCollapseCards() {
        if (!this.isExpanded) {
            this.expandCards()
        } else {
            this.collapseCards()
        }
        this.isExpanded = !this.isExpanded;
    }

    expandCards() {
        if (this.isExpanded) {
            return
        }
        let cardsWidth = 0;
        let cardsHeight = 0;
        let cardsX = 0;
        let cardsY = 0;
        this.cards.forEach((card, index) => {
            card.container.scale.set((this.inRowVisibleCardWidth * 1.25) / card.cardSprite.texture.width)
            const offset = 5;
            const x = this.playerZoneWidth / 2 - ((this.cards.length / 2 - index) * (card.container.width + offset))
            const y = -20
            card.setPosition(x, y)
            card.updateIsExpanded(true)
            if (index !== this.cards.length - 1) {
                cardsWidth += card.container.width + offset
            } else {
                cardsWidth += card.container.width

            }
            if (index === 0) {
                cardsHeight = card.container.height
                cardsX = x;
                cardsY = y;
            }
        })

        this.expandedCardsBackground.clear();
        this.expandedCardsBackground.roundRect(cardsX - 10, cardsY - 10, cardsWidth + 20, cardsHeight + 20, 25).fill({ color: 0x000000, alpha: 0.5 });
        this.setCardsSelectionStatus(true)

    }

    collapseCards() {
        if (!this.isExpanded) {
            return
        }
        this.cards.forEach((card, index) => {
            const cardsPosition: Point = this.cardPosition(index, false, this.cards.length);
            card.setPosition(cardsPosition.x, cardsPosition.y)
            card.container.scale.set(this.inRowVisibleCardWidth / card.cardSprite.texture.width)
            card.updateIsExpanded(false)
        })
        this.expandedCardsBackground.clear();
        //this.setCardsSelectionStatus(false)
    }

    setCardsSelectionStatus(isSelectable: boolean) {
        this.isSelectable = isSelectable;
        this.cards.forEach(card => {
            if (isSelectable === false && card.selected) {
                card.selectCard()
            }
            card.setCardSelectionStatus(isSelectable)
        })
    }

    /**
     * @description
     * Draw games on Restore cards selection
     */
    markCardsAsSelected(cards: CardData[]) {
        cards.forEach(card => {
            const selectedCard = this.cards.find(c => c.info.name === card.name);
            if (selectedCard) {
                selectedCard.markAsSelected()
            }
        })

    }

    setCard(card: Card, index: number, rotateCard: boolean, isPublic: boolean, cards: CardData[]) {
        if (!rotateCard) {
            const cardsPosition: Point = this.cardPosition(index, isPublic, cards.length);

            card.setPosition(cardsPosition.x, cardsPosition.y)
            card.container.scale.set(this.inRowVisibleCardWidth / card.cardSprite.texture.width)

            return card
        }



        const setX = this.playerZoneWidth / 2 - this.infoBoxWidth / 2 - this.playerZoneWidth * 0.02
        const setY = this.playerAvatarCircleSize / 2 + this.playerZoneHeight * 0.07

        switch (index) {
            case 0:
                card.setPosition(setX, setY);
                card.container.rotation = -0.275 - (index * 0.275)
                card.container.scale.set(0.8);
                break;
            case 1:
                card.setPosition(setX - 20, setY + 20);
                card.container.rotation = -0.275 - (index * 0.275)
                card.container.scale.set(0.75);

                break;

            case 2:
                card.setPosition(setX - 35, setY + 45);
                card.container.rotation = -0.275 - (index * 0.275)
                card.container.scale.set(0.7);

                break;

            case 3:
                card.setPosition(setX - 40, setY + 75);
                card.container.rotation = -0.275 - (index * 0.275)
                card.container.scale.set(0.65);
                break;

            case 4:
                card.setPosition(setX - 40, setY + 105);
                card.container.rotation = -0.275 - (index * 0.275)
                card.container.scale.set(0.6);

                break;

            case 5:
                card.setPosition(setX - 30, setY + 135);
                card.container.rotation = -0.275 - (index * 0.275)
                card.container.scale.set(0.55);
                break;

            case 6:
                card.setPosition(setX - 15, setY + 160);
                card.container.rotation = -0.275 - (index * 0.275)
                card.container.scale.set(0.5);
                break;
        }


        return card
    }



    private cardPosition(cardIndex: number, isPublic: boolean, numberOfCards: number): Point {


        let offset: number = 0;
        let cardsWidth;

        while (!cardsWidth || cardsWidth > this.playerZoneWidth) {
            if (offset > 0) {
                offset -= 0.01
            } else {
                offset = 0.5 // default offset
            }

            cardsWidth = this.inRowVisibleCardWidth + (numberOfCards - 1) * (this.inRowVisibleCardWidth * (offset))
        }

        let cardSizeYOffset = 0;
        if (this.cardSize === CardSize.large) {
            cardSizeYOffset -= 12;
        } else if (this.cardSize === CardSize.extraLarge) {
            cardSizeYOffset -= 24;
        }
        const x = this.inRowVisibleCardWidth * offset * cardIndex + (this.playerZoneWidth - cardsWidth) / 2
        const y = this.playerAvatarCircleSize / 2 + (isPublic ? -20 : 0) + cardSizeYOffset

        return { x, y } // isPublic : 7Stud

    }

    removeAllCards() {
        this.container.removeChildren();
        this.cards = [];
        this.r2tCards = [];
        this.expandedCardsBackground.clear();
        this.container.addChild(this.expandedCardsBackground);
    }


    /**
     * @description
     * Winner cards selection
     */
    selectCards(cardsToSelect: CardData[] = []) {

        if (cardsToSelect.length === 0) { return }

        this.cards.concat(this.r2tCards).forEach(card => {
            if (!card || !card.info) { return; }
            if (cardsToSelect.findIndex(selectCard => selectCard.suit === card.info.suit && selectCard.number === card.info.number) === -1) {
                card.grayscaleCard();
            } else {
                card.ungrayscaleCard();
            }
        });
    }

    grayscaleCards() {
        this.cards.concat(this.r2tCards).forEach(card => {
            card.grayscaleCard()
        })
    }


    destroy(): void {
        if (this._isDestroyed) return;
        this._isDestroyed = true;

        // 1) Stop selection streams and let subscribers finish
        try {
            // Notify last state (optional)
            // this.cards$.next([]);
        } catch { }
        this.cards$.complete();
        // cardsSelected$ is derived; nothing to complete here.

        // 2) Destroy card instances (they may have their own listeners/subjects)
        for (const c of this.cards) {
            // Prefer a card.destroy() if it exists:
            if (typeof (c as any).destroy === 'function') {
                (c as any).destroy({ destroyTextures: false });
            } else {
                // Fallback: remove listeners and destroy container only
                c.container?.removeAllListeners?.();
                c.container?.destroy({ children: true, texture: false });
            }
        }
        for (const c of this.r2tCards) {
            if (typeof (c as any).destroy === 'function') {
                (c as any).destroy({ destroyTextures: false });
            } else {
                c.container?.removeAllListeners?.();
                c.container?.destroy({ children: true, texture: false });
            }
        }

        // 3) Clear internal arrays and graphics
        this.cards = [];
        this.r2tCards = [];

        // Expanded cards bg (is a child of container)
        // If we destroy the container with children below, it will be destroyed automatically.
        // If not, explicitly clear & destroy it:
        this.expandedCardsBackground?.clear?.();

        // 4) Remove any interaction listeners set on the controller-level container
        this.container?.removeAllListeners?.();

        // 5) Destroy the container and all remaining children (safe: no textures/baseTextures)
        this.container?.destroy({ children: true, texture: false });

        // 6) Drop references
        (this.expandedCardsBackground as any) = null;
        (this.container as any) = null;
    }
}
